import WhatsappMessageCard from './WhatsappMessagesCard';

const WhatsappMessagesCards = ({ whatsappMessages, stats, period }) => {
  return whatsappMessages.map((whatsappMessage) => {
    return (
      <WhatsappMessageCard key={whatsappMessage.id} whatsappMessage={whatsappMessage} stats={stats} period={period} />
    );
  });
};

export default WhatsappMessagesCards;
